import { formatNumber } from '@pkgs/components/utils/numberFormatters';
import { type BigDecimalRangeDto, type Language, type MeasurementSystem, UNIT_SYMBOL_MAP } from '@pkgs/api';

type FormatValueWithUnitParams = {
  value: number;
  measurementSystem: MeasurementSystem;
  language: Language;
  isSurface?: boolean;
  shouldShowRoundedValue?: boolean;
};

export const formatValueWithUnit = ({
  value,
  measurementSystem,
  language,
  isSurface,
  shouldShowRoundedValue,
}: FormatValueWithUnitParams) => {
  if (!isSurface) {
    return formatNumber({ number: value, language }, { maximumFractionDigits: 2 });
  }
  const formattedNumber = formatNumber(
    { number: value, language, shouldShowRoundedValue },
    { maximumFractionDigits: shouldShowRoundedValue ? 0 : 1 },
  );
  return `${formattedNumber} ${UNIT_SYMBOL_MAP[measurementSystem]}`;
};

type FormatRangeWithUnitParams = {
  values: BigDecimalRangeDto;
  measurementSystem: MeasurementSystem;
  language: Language;
  isSurface?: boolean;
};
export const formatRangeWithUnit = ({ values, measurementSystem, isSurface, language }: FormatRangeWithUnitParams): string => {
  const { min, max } = values;
  const formattedMin = min ? formatNumber({ number: min, language }, { maximumFractionDigits: 2 }) : '0';
  const formattedMax = max ? formatNumber({ number: max, language }, { maximumFractionDigits: 2 }) : '0';

  // If min and max are the same, only show one value
  const value = formattedMin === formattedMax ? formattedMin : `${formattedMin} - ${formattedMax}`;

  if (!isSurface) return value;

  return `${value} ${UNIT_SYMBOL_MAP[measurementSystem]}`;
};
